import type { CacheKey } from '../utils/internalTypings';
import type { QueryByIdArg } from './createEntityTypes';

export function mapListToIndexedObject<Entity>(
    entityList: Entity[],
    selectId: CacheKey<Entity>,
): Record<string, Entity> {
    return entityList.reduce(
        (acc, entity) => {
            acc[selectId(entity)] = entity;
            return acc;
        },
        {} as Record<string, Entity>,
    );
}

export function buildCombinedArgumentFromIdAndParams(id: string, args: any): QueryByIdArg {
    if (typeof args === 'string' || !args) {
        return id;
    }
    return {
        ...args,
        id,
    };
}

export function getIdFromArgs(args?: any): string {
    if (typeof args === 'string') {
        return args ?? '';
    }

    return args?.id ?? '';
}
